import { useTheme } from '@/src/context/ThemeContext';
import React, { useRef } from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import Svg, { Defs, Path, Pattern, Rect } from 'react-native-svg';

export function PatternBackground({ children }: { children: React.ReactNode }) {
  const { colors, isDark } = useTheme();
  const { width, height } = useWindowDimensions();
  const strokeColor = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.05)';

  // Unique pattern ID per instance avoids SVG def conflicts when Expo Router
  // mounts multiple screens simultaneously (e.g. drawer navigation on web).
  const patternId = useRef(`diamonds-${Math.random().toString(36).slice(2)}`).current;

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <Svg style={StyleSheet.absoluteFill} width={width} height={height}>
        <Defs>
          <Pattern id={patternId} x="0" y="0" width="24" height="24" patternUnits="userSpaceOnUse">
            <Path d="M12,1 L23,12 L12,23 L1,12 Z" fill="none" stroke={strokeColor} strokeWidth="0.75" />
          </Pattern>
        </Defs>
        <Rect width={width} height={height} fill={`url(#${patternId})`} />
      </Svg>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
});
